var _ = Object.create, u = Object.defineProperty, s = Object.getOwnPropertyDescriptor, f = Object.getOwnPropertyNames, c = Object.getPrototypeOf, v = Object.prototype.hasOwnProperty, O = (e, r) => () => (r || (e((r = { exports: {} }).exports, r), e = null), r.exports), b = (e, r) => {
  let t = {};
  for (var o in e)
    u(t, o, {
      get: e[o],
      enumerable: !0
    });
  return r || u(t, Symbol.toStringTag, { value: "Module" }), t;
}, g = (e, r, t, o) => {
  if (r && typeof r == "object" || typeof r == "function")
    for (var i = f(r), a = 0, p = i.length, n; a < p; a++)
      n = i[a], !v.call(e, n) && n !== t && u(e, n, {
        get: ((l) => r[l]).bind(null, n),
        enumerable: !(o = s(r, n)) || o.enumerable
      });
  return e;
}, P = (e, r, t) => (t = e != null ? _(c(e)) : {}, g(r || !e || !e.__esModule ? u(t, "default", {
  value: e,
  enumerable: !0
}) : t, e)), d = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (r, t) => (typeof require < "u" ? require : r)[t] }) : e)(function(e) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Calling `require` for "' + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
});
export {
  P as i,
  b as n,
  d as r,
  O as t
};
